<template>
  <FormItem :prop="name" :label="label">
    <Input
      ref="formInput"
      v-bind="$attrs"
      v-on="$listeners"
      :decorator="decorator"
      class="cust-form-input"
    />
  </FormItem>
</template>

<script>
import { FormModel, Input } from "ant-design-vue";
export default {
  components: {
    FormItem: FormModel.Item,
    Input
  },
  props: {
    name: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    decorator: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss">
textarea.cust-form-input {
  height: 8rem !important;
}
</style>
